import {ICON_TYPES} from '../constants';

export const LoaderLarge = (): JSX.Element => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='64'
      height='64'
      viewBox='0 0 64 64'
      fill='none'>
      <g clipPath='url(#clip0_77_13516)'>
        <path
          d='M18.8007 18.8007C21.4042 16.1972 21.4042 11.9761 18.8007 9.37256C16.1972 6.76907 11.9761 6.76907 9.37258 9.37256C6.76909 11.9761 6.76909 16.1972 9.37258 18.8007C11.9761 21.4041 16.1972 21.4041 18.8007 18.8007Z'
          fill='#2C2A27'
        />
        <path
          opacity='0.4'
          d='M36.714 11.4468C39.3175 8.84328 39.3175 4.62218 36.714 2.01868C34.1105 -0.584812 29.8894 -0.584812 27.2859 2.01868C24.6824 4.62218 24.6824 8.84328 27.2859 11.4468C29.8894 14.0503 34.1105 14.0503 36.714 11.4468Z'
          fill='#2C2A27'
        />
        <path
          opacity='0.4'
          d='M54.6273 18.8007C57.2308 16.1972 57.2308 11.9761 54.6273 9.37256C52.0238 6.76907 47.8027 6.76907 45.1992 9.37256C42.5957 11.9761 42.5957 16.1972 45.1992 18.8007C47.8027 21.4041 52.0238 21.4041 54.6273 18.8007Z'
          fill='#2C2A27'
        />
        <path
          opacity='0.4'
          d='M61.9813 36.714C64.5848 34.1106 64.5848 29.8894 61.9813 27.286C59.3778 24.6825 55.1567 24.6825 52.5532 27.286C49.9497 29.8895 49.9497 34.1105 52.5532 36.714C55.1567 39.3175 59.3778 39.3175 61.9813 36.714Z'
          fill='#2C2A27'
        />
        <path
          opacity='0.4'
          d='M54.6273 54.6274C57.2308 52.0239 57.2308 47.8028 54.6273 45.1993C52.0238 42.5959 47.8027 42.5959 45.1992 45.1993C42.5957 47.8028 42.5957 52.0239 45.1992 54.6274C47.8027 57.2309 52.0238 57.2309 54.6273 54.6274Z'
          fill='#2C2A27'
        />
        <path
          opacity='0.4'
          d='M36.714 61.9813C39.3175 59.3778 39.3175 55.1567 36.714 52.5532C34.1105 49.9497 29.8894 49.9497 27.2859 52.5532C24.6824 55.1567 24.6824 59.3778 27.2859 61.9813C29.8894 64.5848 34.1105 64.5848 36.714 61.9813Z'
          fill='#2C2A27'
        />
        <path
          opacity='0.6'
          d='M18.8007 54.6274C21.4042 52.0239 21.4042 47.8028 18.8007 45.1993C16.1972 42.5958 11.9761 42.5959 9.37258 45.1993C6.76909 47.8028 6.76909 52.0239 9.37258 54.6274C11.9761 57.2309 16.1972 57.2309 18.8007 54.6274Z'
          fill='#2C2A27'
        />
        <path
          opacity='0.8'
          d='M11.4468 36.714C14.0503 34.1105 14.0503 29.8895 11.4468 27.286C8.84327 24.6825 4.62217 24.6825 2.01867 27.286C-0.584823 29.8894 -0.584823 34.1106 2.01867 36.714C4.62217 39.3175 8.84327 39.3175 11.4468 36.714Z'
          fill='#2C2A27'
        />
      </g>
      <defs>
        <clipPath id='clip0_77_13516'>
          <rect width='64' height='64' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
};

LoaderLarge.iconType = ICON_TYPES.LOADER_LARGE;
